document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('cart-drawer--preload');
      cartDrawer.classList.remove('hidden');
    }
  }, 1200);
});

// Wallet buttons: sizing and "Shop Pay only, full width" are handled in
// cart-drawer.liquid with Shopify's supported CSS variables and the
// additional-checkout-buttons--vertical class. Shopify renders the buttons
// in a closed shadow DOM, so the old trimWalletButtons() DOM walk was removed.


function openCartDrawer() {
  const drawer = document.querySelector(".cart-drawer");
  // If someone adds to cart within the first 1.2s, the preload class would
  // keep the drawer invisible even though it's "open" — clear it here too.
  drawer.classList.remove("cart-drawer--preload");
  drawer.classList.remove("hidden");
  drawer.classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function setCartDrawerLoading(isLoading) {
  const box = document.querySelector(".cart-drawer-box");
  if (!box) return;
  box.classList.toggle("is-loading", isLoading);
}

// ── Request sequencing ──────────────────────────────────────────────
// Every cart request takes a ticket. When a response comes back, it only
// gets rendered if it's still the newest ticket — so rapid taps can't
// paint an older cart state over a newer one.
let cartRequestSeq = 0;
function nextCartRequest() {
  return ++cartRequestSeq;
}
function isLatestCartRequest(seq) {
  return seq === cartRequestSeq;
}

// Renders the drawer from section HTML. If `prefetchedHTML` is provided
// (e.g. from the Cart API's `sections` response), no extra network request
// is made; otherwise it falls back to fetching the section.
async function updateCartDrawer(prefetchedHTML) {
  let text = prefetchedHTML;
  if (!text) {
    const res = await fetch("/?section_id=cart-drawer");
    text = await res.text();
  }
  const html = document.createElement("div");
  html.innerHTML = text;

  const drawer = document.querySelector(".cart-drawer");
  const newDrawer = html.querySelector(".cart-drawer");
  if (!drawer || !newDrawer) return;

  // Preserve scroll position across the re-render so the drawer doesn't
  // jump back to the top every time a quantity changes.
  const scroll = drawer.querySelector(".cart-drawer-scroll");
  const scrollTop = scroll ? scroll.scrollTop : 0;

  // 1. Replace the scrollable middle (shipping, items, gift options, bundle box)
  const newScroll = newDrawer.querySelector(".cart-drawer-scroll");
  if (scroll && newScroll) {
    scroll.innerHTML = newScroll.innerHTML;
    scroll.scrollTop = scrollTop;
  }

  // 2. Header item count
  const count = drawer.querySelector(".cart-drawer-header-right-items");
  const newCount = newDrawer.querySelector(".cart-drawer-header-right-items");
  if (count && newCount) count.textContent = newCount.textContent;

  // 3. Footer: swap only the discount/subtotal rows and sync visibility.
  //    The wallet-button container is NEVER replaced — Shopify's SDK
  //    initializes those buttons once at page load, and replacing their
  //    markup leaves dead, unclickable copies.
  //    Rows go in above the gift link so the order always matches the
  //    Liquid: discount → subtotal → gift link → rewards → checkout.
  const footer = drawer.querySelector(".cart-drawer-footer");
  const newFooter = newDrawer.querySelector(".cart-drawer-footer");
  if (footer && newFooter) {
    footer.querySelectorAll(".cart-drawer-footer-row").forEach((row) => row.remove());
    const anchor =
      footer.querySelector(".cart-drawer-gift-cta") ||
      footer.querySelector(".cart-drawer-rewards-note") ||
      footer.querySelector(".cart-drawer-button");
    Array.from(newFooter.querySelectorAll(".cart-drawer-footer-row")).forEach((row) => {
      footer.insertBefore(row, anchor);
    });
    footer.classList.toggle(
      "cart-drawer-footer--hidden",
      newFooter.classList.contains("cart-drawer-footer--hidden")
    );
  }

  // 4. Refresh modal contents (gift message prefill values etc.)
  ["giftWrapModal", "giftBagModal"].forEach((id) => {
    const oldModal = drawer.querySelector("#" + id);
    const newModal = newDrawer.querySelector("#" + id);
    if (oldModal && newModal) oldModal.innerHTML = newModal.innerHTML;
  });

  addCartDrawerListeners();
  giftBagListener();
  cartDrawerFormSearch(drawer); // only rescan the drawer, not the whole page
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
  updateCountBubble(count);
}

// If a cart update leaves ONLY gift products (wrap/bags) with no real items,
// remove the gift items too and clear the gift_wrap attribute. Returns the
// final cart (possibly after a second update request). When it does issue a
// second update, it asks for the rendered drawer section back so the caller
// can re-render without another request (cart.sections['cart-drawer']).
async function cleanupGiftItems(cart) {
  const GIFT_HANDLES = ["gift-wrapping", "large-gift-bag"];
  const items = (cart && cart.items) || [];
  const giftItems = items.filter((i) => GIFT_HANDLES.includes(i.handle));
  const hasRealItems = items.some((i) => !GIFT_HANDLES.includes(i.handle));

  if (hasRealItems || giftItems.length === 0) return cart;

  const updates = {};
  giftItems.forEach((i) => {
    updates[i.id] = 0;
  });

  const res = await fetch("/cart/update.js", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      updates,
      attributes: { gift_wrap: null },
      sections: "cart-drawer",
    }),
  });
  return await res.json();
}


function updateCountBubble(n) {
  const cartCountBubble = document.querySelector('.cart-count-bubble');
  const cartIcon = document.querySelector("#cart-icon-bubble");

  // Si n es 0, elimina la burbuja si existe y sal de la función
  if (n === 0) {
    if (cartCountBubble) {
      cartCountBubble.remove();
      if (cartIcon) cartIcon.classList.add("empty");
    }
    return;
  } else {
    if (cartIcon) cartIcon.classList.remove("empty");
  }

  if (cartCountBubble) {
    // Actualiza el número en la burbuja existente
    const countText = cartCountBubble.querySelector('.pt-1');
    if (countText) {
      countText.innerText = n;
    }
  } else {
    // Crea y agrega una nueva burbuja si no existe
    const headerIcon = document.querySelector(".header__icon.link.link--text.focus-inset.relative");
    if (headerIcon) {
      const newBubble = document.createElement("div");
      newBubble.className = "cart-count-bubble";
      newBubble.innerHTML = `<span aria-hidden="true" class="pt-1">${n}</span>`;
      headerIcon.appendChild(newBubble);
    }
  }
}


// ── Quantity changes: optimistic + coalesced ────────────────────────
// The number in the drawer updates the instant you tap. The actual
// request is held for a brief moment so a burst of taps (1 → 2 → 3 → 4)
// becomes ONE request for the final quantity instead of four in a row.
const pendingQtyTimers = {};
const QTY_COALESCE_MS = 350;

function scheduleQuantityUpdate(key, newQuantity) {
  clearTimeout(pendingQtyTimers[key]);
  pendingQtyTimers[key] = setTimeout(() => {
    delete pendingQtyTimers[key];
    sendQuantityUpdate(key, newQuantity);
  }, QTY_COALESCE_MS);
}

async function sendQuantityUpdate(key, newQuantity) {
  const seq = nextCartRequest();
  setCartDrawerLoading(true);
  try {
    // Ajax update — ask Shopify to return the rendered drawer section in
    // the same response, so we don't need a second request to re-render.
    const res = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: { [key]: newQuantity },
        sections: "cart-drawer",
      }),
    });
    let cart = await res.json();

    // If only gift wrap/bags remain, remove them too (this may return a
    // newer cart with its own rendered section)
    cart = await cleanupGiftItems(cart);

    // A newer tap already fired its own request — let that one render.
    if (!isLatestCartRequest(seq)) return;

    updateCartItemCounts(cart.item_count);

    // Update cart from the piggybacked section HTML (falls back to a
    // section fetch if it's missing for any reason)
    await updateCartDrawer(cart.sections && cart.sections["cart-drawer"]);
  } catch (err) {
    console.error("Cart update failed:", err);
    if (isLatestCartRequest(seq)) await updateCartDrawer(); // re-sync with the real cart
  } finally {
    if (isLatestCartRequest(seq)) setCartDrawerLoading(false);
  }
}

function addCartDrawerListeners() {
  // Update quantities
  document.querySelectorAll(".cart-drawer-quantity-selector button").forEach((button) => {
    if (button.dataset.boundQty) return;
    button.dataset.boundQty = "true";

    button.addEventListener("click", () => {
      // Get line item key
      const rootItem = button.closest("[data-line-item-key]");
      if (!rootItem) return;
      const key = rootItem.getAttribute("data-line-item-key");

      // Get new quantity (remove-only selectors, like gift wrap, have no input)
      const quantityInput = button.parentElement.querySelector("input");
      const currentQuantity = quantityInput ? Number(quantityInput.value) : 0;
      const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
      const isZero = button.classList.contains("remove-item");
      let newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
      newQuantity = isZero ? 0 : Math.max(0, newQuantity);

      // Optimistic UI: show the new number immediately; fade the row out
      // if it's being removed. The server response reconciles everything.
      if (quantityInput) quantityInput.value = newQuantity;
      if (newQuantity === 0) {
        rootItem.style.opacity = "0.35";
        rootItem.style.pointerEvents = "none";
        // Removals go straight through — no reason to wait
        clearTimeout(pendingQtyTimers[key]);
        delete pendingQtyTimers[key];
        sendQuantityUpdate(key, 0);
      } else {
        scheduleQuantityUpdate(key, newQuantity);
      }
    });
  });

  const box = document.querySelector(".cart-drawer-box");
  if (box && !box.dataset.boundStop) {
    box.addEventListener("click", (e) => {
      e.stopPropagation();
    });
    box.dataset.boundStop = "true";
  }

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      if (el.dataset.boundClose) return;
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
      el.dataset.boundClose = "true";
    });
}

addCartDrawerListeners();



// Full-refresh path (used by product-form / external callers after an
// add-to-cart). ONE request: /cart/update.js with no changes returns the
// cart JSON *and* the rendered drawer section together, instead of the
// old /cart.js + /?section_id=cart-drawer double round trip.
async function handleCartUpdate() {
  openCartDrawer();
  const seq = nextCartRequest();
  setCartDrawerLoading(true);
  try {
    const res = await fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: {}, sections: "cart-drawer" }),
    });
    let cart = await res.json();
    cart = await cleanupGiftItems(cart);
    if (!isLatestCartRequest(seq)) return;
    updateCartItemCounts(cart.item_count);
    await updateCartDrawer(cart.sections && cart.sections["cart-drawer"]);
  } finally {
    if (isLatestCartRequest(seq)) setCartDrawerLoading(false);
  }
}

// Binds AJAX add-to-cart to plain /cart/add forms. Pass a root element to
// limit the scan (the drawer re-render only needs to rescan itself).
function cartDrawerFormSearch(root) {
  (root || document).querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    // Skip forms already handled by <product-form>
    if (form.closest("product-form")) return;

    // Skip forms that bring their own AJAX handler (e.g. the sticky ATC bar)
    if (form.dataset.ownAjax) return;

    // Fix multiple add.js calls
    if (form.dataset.ajaxBound) return;

    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // 1. Open the drawer IMMEDIATELY so the customer gets instant
      //    feedback, with a loading state while the add completes.
      openCartDrawer();
      const seq = nextCartRequest();
      setCartDrawerLoading(true);

      try {
        // 2. Single round trip: /cart/add.js with `sections` returns both
        //    the add result and the freshly rendered drawer HTML.
        const formData = new FormData(form);
        formData.append("sections", "cart-drawer");

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        });
        const data = await res.json();

        // Add failed (sold out, invalid variant, etc.) — Shopify returns
        // { status, message, description } instead of the line item.
        if (!res.ok || (data.status && data.status !== 200)) {
          console.error("Add to cart failed:", data.description || data.message || res.status);
          if (isLatestCartRequest(seq)) await updateCartDrawer(); // re-sync drawer with actual cart state
          return;
        }

        if (!isLatestCartRequest(seq)) return;

        // 3. Render the drawer from the piggybacked HTML — no extra request.
        await updateCartDrawer(data.sections && data.sections["cart-drawer"]);

        // 4. Count bubble + gift-item cleanup run in the background; they
        //    no longer block the drawer from appearing.
        fetch("/cart.js")
          .then((r) => r.json())
          .then(async (cart) => {
            const itemCountBefore = cart.item_count;
            const cleaned = await cleanupGiftItems(cart);
            updateCartItemCounts(cleaned.item_count);
            // Only re-render if cleanup actually changed the cart
            if (cleaned.item_count !== itemCountBefore && isLatestCartRequest(seq)) {
              await updateCartDrawer(cleaned.sections && cleaned.sections["cart-drawer"]);
            }
          })
          .catch(() => {});
      } finally {
        if (isLatestCartRequest(seq)) setCartDrawerLoading(false);
      }
    });

    // Mark as bound
    form.dataset.ajaxBound = "true";
  });
}

cartDrawerFormSearch();




// Header/site links to /cart open the drawer instead of the cart page.
// The drawer's own gift link is excluded — it's meant to go to /cart.
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  if (a.classList.contains("cart-drawer-gift-cta")) return;
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});


// modal 

function toggleModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal.classList.contains('hidden')) {
    modal.classList.remove('hidden');
    modal.style.display = 'flex';
  } else {
    modal.classList.add('hidden');
    modal.style.display = 'none';
  }
}



// gift bag logic


function giftBagListener() {
  const bagWithMessage = document.querySelector('.cart-drawer-box #giftWrapCheckbox');
  const multipleBag = document.querySelector('.cart-drawer-box #giftBagCheckbox');

  // Empty cart: gift checkboxes are not rendered, nothing to bind
  if (!bagWithMessage || !multipleBag) return;

  const disableCheckoboxes = () => {
    [bagWithMessage, multipleBag].map(checkbox => {
      checkbox.disabled = true;
      return;
    })
  }

  const bagWithMessageProductId = bagWithMessage.dataset.bagId;
  const multipleBagProductIds = multipleBag.dataset.bagIds.split(",");

  bagWithMessage.addEventListener("change", async (e) => {
    disableCheckoboxes();
    const checkbox = e.target;
    //const productId = checkbox.dataset.bagId;
    if (!checkbox.checked) {

      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [bagWithMessageProductId]: 0 }, attributes: { gift_wrap: null }, sections: "cart-drawer" }),
      }).then(async response => {
        const cart = await response.json();
        updateCartDrawer(cart.sections && cart.sections["cart-drawer"]);

      });
    } else {


      const updates = multipleBagProductIds.reduce((acc, productId) => {
        acc[productId] = 0;
        return acc;
      }, {});
      // update.js sets absolute quantities, so gift wrap can never exceed 1
      updates[bagWithMessageProductId] = 1;

      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates, attributes: { gift_wrap: "whole" }, sections: "cart-drawer" }),
      }).then(async response => {
        const cart = await response.json();
        await updateCartDrawer(cart.sections && cart.sections["cart-drawer"]).then(response => {
          toggleModal('giftWrapModal');
          giftMessageAttr();
        })
      });
    }
  });

  const giftMessageAttr = () => {
    const giftMessageForm = document.querySelector("#giftMessage");
    giftMessageForm.addEventListener("submit", async e => {
      e.preventDefault();
      const data = new FormData(e.target);
      const formDataObject = Object.fromEntries(data.entries());
      const note = Object.entries(formDataObject).map(([key, value]) => `${key.toUpperCase()}: ${value || ''}`).join("\n");

      await fetch("/cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ attributes: formDataObject,note }),
      }).then(response => {
        toggleModal('giftWrapModal');

      });
    });

  }

  multipleBag.addEventListener("change", async (e) => {

    disableCheckoboxes();
    const checkbox = e.target;

    if (!checkbox.checked) {
      const updates = multipleBagProductIds.reduce((acc, productId) => {
        acc[productId] = 0;
        return acc;
      }, {});

      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          updates,
          attributes: { gift_wrap: null },
          sections: "cart-drawer",
        }),
      }).then(async response => {
        const cart = await response.json();
        updateCartDrawer(cart.sections && cart.sections["cart-drawer"]);
      });
    } else {

      await fetch("/cart/add.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          'items': [{
            'id': multipleBagProductIds[0],
            'quantity': 1
          }], attributes: { gift_wrap: "multiple" }
        }),
      }).then(async response => {

        await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [bagWithMessageProductId]: 0 }, sections: "cart-drawer" }),
        }).then(async response => {
          const cart = await response.json();
          await updateCartDrawer(cart.sections && cart.sections["cart-drawer"]).then(response => {
            toggleModal('giftBagModal');
            cartDrawerFormSearch(document.querySelector('.cart-drawer'));
          })
        });
      });

    }
  });

}


giftBagListener();
